// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sub-heading {\n    margin: 40px 0px 20px 0px;\n    text-indent: -0.5in;\n    line-height: 115%;\n}\n.i18n-ar .sub-heading, .i18n-ar .ug-heading {\n    text-align: right;\n}\n.bullet{\n    margin-right:10px;\n}\n", ""]);
// Exports
module.exports = exports;
